import { Button, Dialog } from '@neo4j-ndl/react';

interface ModalProps {
  onClose?: () => void;
  onConfirm?: () => void;
  title: string;
  isLoading: boolean;
  mfaEnabled: boolean;
  description: string;
}

const NEW_PAGE_LAYOUT_MFA_DISABLE_MODAL_DESCR =
  'Disabling MFA will significantly reduce your account security. Are you sure you would like to proceed?';

const MFA_ENABLE_MODAL_DESCR =
  'Once enabled, you will be required to login with a One Time Passcode which can be set up using an authenticator app of your choice.';

export const ConfirmMfaModal = (props: ModalProps) => {
  const { onClose, onConfirm, title, isLoading, mfaEnabled, description } = props;

  let type: 'info' | 'warning' | undefined = undefined;
  type = mfaEnabled ? 'warning' : 'info';

  const disableContent = () => {
    return (
      <span>
        <span className="font-bold">IMPORTANT: </span>
        {NEW_PAGE_LAYOUT_MFA_DISABLE_MODAL_DESCR}
      </span>
    );
  };

  return (
    <Dialog isOpen onClose={onClose} size="unset" modalProps={{ className: 'max-w-[768px]' }} type={type}>
      <Dialog.Header>{title}</Dialog.Header>
      <Dialog.Content>{mfaEnabled ? disableContent() : MFA_ENABLE_MODAL_DESCR}</Dialog.Content>
      {!mfaEnabled && <Dialog.Description>{description}</Dialog.Description>}
      <Dialog.Actions>
        <Button fill="outlined" color="neutral" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onConfirm} isLoading={isLoading}>
          {`${mfaEnabled ? 'Disable' : 'Enable'} MFA`}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};
